import type { MarketStoreListItem } from '../orders/_consts/constants';
import type { RegisteredMarketInfo } from './market-types';

const MARKET_ICON_URLS = {
  smartstore:
    'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketSmartstore.png',
  coupang:
    'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketCoupang.png',
  gmarket:
    'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketGmarket.png',
  elevenStreet:
    'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarket11st.png',
} as const;

const registeredMarketList: RegisteredMarketInfo[] = [
  {
    AccessKey: '',
    HasToChangePassword: false,
    IsAliasEnable: true,
    IsAiSellerEnable: true,
    IsSmartstoreManagerPending: false,
    MarketAlias: '셀러박스 공식몰',
    MarketIconUrl: MARKET_ICON_URLS.smartstore,
    MarketId: 'sellerbox-official',
    MarketName: '스마트스토어',
    MarketNameEnglish: 'smartstore',
    MarketPassword: '',
    MarketType: 'naver',
    SecretKey: '',
    StoreComment: '',
    StoreId: 'sellerbox-official',
    StoreName: '셀러박스 공식몰',
    VendorId: '',
  },
  {
    AccessKey: '',
    HasToChangePassword: false,
    IsAliasEnable: true,
    IsAiSellerEnable: true,
    IsSmartstoreManagerPending: false,
    MarketAlias: '활기찬마켓',
    MarketIconUrl: MARKET_ICON_URLS.gmarket,
    MarketId: 'active-market',
    MarketName: 'G마켓',
    MarketNameEnglish: 'gmarket-new',
    MarketPassword: '',
    MarketType: 'esm',
    SecretKey: '',
    StoreComment: '',
    StoreId: 'active-market',
    StoreName: '활기찬마켓',
    VendorId: '',
  },
  {
    AccessKey: '',
    HasToChangePassword: false,
    IsAliasEnable: true,
    IsAiSellerEnable: true,
    IsSmartstoreManagerPending: false,
    MarketAlias: 'Leader',
    MarketIconUrl: MARKET_ICON_URLS.elevenStreet,
    MarketId: 'leader-store',
    MarketName: '11번가',
    MarketNameEnglish: '11st',
    MarketPassword: '',
    MarketType: 'eleven-street',
    SecretKey: '',
    StoreComment: '',
    StoreId: 'leader-store',
    StoreName: 'Leader',
    VendorId: '',
  },
  {
    AccessKey: '',
    HasToChangePassword: false,
    IsAliasEnable: true,
    IsAiSellerEnable: true,
    IsSmartstoreManagerPending: false,
    MarketAlias: '워치케치',
    MarketIconUrl: MARKET_ICON_URLS.coupang,
    MarketId: 'watchcatch',
    MarketName: '쿠팡',
    MarketNameEnglish: 'coupang',
    MarketPassword: '',
    MarketType: 'coupang',
    SecretKey: '',
    StoreComment: '쿠팡 Wing ID 확인이 필요해요.',
    StoreId: 'watchcatch',
    StoreName: '워치케치',
    VendorId: 'watchcatch',
  },
];

const referenceMarketArray: MarketStoreListItem[] = registeredMarketList.map((market, index) => ({
  MarketId: index + 1,
  MarketName: market.MarketName,
  MarketNameEnglish: market.MarketNameEnglish,
  MarketIconUrl: market.MarketIconUrl,
  StoreId: market.StoreId ?? market.MarketId,
  StoreName: market.StoreName ?? market.MarketAlias,
  MarketAlias: market.MarketAlias,
  MarketSeqNo: index + 1,
}));

export const membershipMarketMock = {
  registeredMarketList,
  referenceMarketArray,
};
